import ApiResource from '../_resource'

export default class extends ApiResource {
  constructor(...args) {
    super(...args)
    this.paramName = 'session'
  }

  read() {
    return super.read(null)
  }
}
